import { initAnimations } from './animationer.js'

import Macy from "macy";


export default () => {
    const macyContainer = document.querySelector('.archive__content--masonry');
    let macyInstance = '';
    if(macyContainer) {
        macyInstance = Macy({
            container: document.querySelector('.archive__content--masonry'),
            columns: 3,
            margin: 20,
            runOnImageLoad: false,
            breakAt: {
                1024: {
                    margin: 10,
                },
                768: {
                    columns: 2,
                },
                450: {
                    columns: 1,
                    margin: 15,
                }
            }
        });
        macyInstance.runOnImageLoad(function () {
            macyInstance.recalculate(true);
        }, true);
    }

    const filterBtns = document.querySelectorAll('.archive__filter');
    let selectedFilter = 0;

    let offset = 8;
    let increment = 9;
    const loadmoreBtn = document.getElementById('loadmore');
    let brandSelect = document.getElementById('brandselect');

    let selectedBrand = '';

    let dataLM = { //data load more
        action: 'nobox_load_more_archive',
        offset: offset,
        type: '',
        increment: increment,
        brand: selectedBrand,
        category: selectedFilter
    };

    filterBtns.forEach(btn => {
        const id = btn.dataset.id;

        btn.addEventListener('click', e => {
            selectedFilter = id;
            let container = document.querySelector('.archive__content--masonry');

            let dataFilter = { //data load more
                action: 'nobox_filter_category_archive',
                category: selectedFilter
            };

            dataLM.offset = 8;
            if(horizon.wpIsMobile) {
                dataLM.offset = 3;
            }

            document.querySelector('.archive__filter.button--primary-outline').classList.remove('button--primary-outline');
            btn.classList.add('button--primary-outline');

            $.post(
                horizon.ajaxUrl,
                dataFilter,
                (data, response) => {
                    if (response === 'success') {
                        container.innerHTML = '';

                        data.result.forEach((post) => {
                            container.appendChild(createElementFromHTML(post));
                        });

                        initAnimations();

                        if(macyContainer) {
                            macyInstance.runOnImageLoad(function () {
                                macyInstance.recalculate(true);
                            }, true);
                        }
                    }
                    if(loadmoreBtn) {
                        if(data.result.length === dataLM.increment) {
                            loadmoreBtn.style.display = "inline-block";
                        } else {
                            loadmoreBtn.style.display = "none";
                        }
                    }
                }
            );
        });
    });


    if(loadmoreBtn) {
        dataLM.type = loadmoreBtn.getAttribute('data-type');
        if(dataLM.type === 'post') {
            dataLM.offset = 10;
            dataLM.increment = 10;
            if(horizon.wpIsMobile) {
                dataLM.offset = 3;
                dataLM.increment = 3;
            }
        }

        loadmoreBtn.addEventListener('click', (e) => {
            dataLM.brand = selectedBrand;
            dataLM.category = selectedFilter;

            loadmoreBtn.innerHTML = "Laddar...";

            let container = document.querySelector('.archive__content');
            if (document.querySelector('.archive__content--masonry')) {
                container = document.querySelector('.archive__content--masonry');
            }

            $.post(
                horizon.ajaxUrl,
                dataLM,
                (data, response) => {
                    if (response === 'success') {
                        loadmoreBtn.innerHTML = "Visa fler";
                        if(data.result.length > 0) {
                            data.result.forEach((post, index) => {
                                const p = createElementFromHTML(post);
                                container.appendChild(p)
                                if (index === 0) {
                                    p.querySelector('a').focus();
                                }
                            });

                            if(data.result.length < dataLM.increment) {
                                loadmoreBtn.style.display = "none";
                            }

                            initAnimations();

                            if(macyContainer) {
                                macyInstance.runOnImageLoad(function () {
                                    macyInstance.recalculate(true);
                                }, true);
                            }

                        } else {
                            loadmoreBtn.style.display = "none";
                        }
                    }
                }
            );
            dataLM.offset += dataLM.increment;
        });
    }

    if(brandSelect) {
        brandSelect.addEventListener('change', (e) => {
            dataLM.offset = 8;
            selectedBrand = e.target.value;
            let postContainer = document.querySelector('.archive__content');

            let dataF = { // data filter
                action: 'nobox_filter_archive',
                type: 'erbjudande',
                increment: 8,
                brand: selectedBrand,
            };

            $.post(
                horizon.ajaxUrl,
                dataF,
                (data, response) => {
                    if (response === 'success') {
                        if(data.result.length > 0) {
                            postContainer.innerHTML = "";
                            data.result.forEach((post) => {
                                postContainer.innerHTML += post;
                            });
                            loadmoreBtn.style.display = "inline-block";
                            initAnimations();
                        }
                    }
                }
            );

        });
    }

};

function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes.
  return div.firstChild;
}
